import { render, staticRenderFns } from "./puOnStorage.vue?vue&type=template&id=e90614ce&scoped=true"
import script from "./puOnStorage.vue?vue&type=script&lang=js"
export * from "./puOnStorage.vue?vue&type=script&lang=js"
import style0 from "./puOnStorage.vue?vue&type=style&index=0&id=e90614ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90614ce",
  null
  
)

export default component.exports